/**
 * DevExtreme (ui/themes_callback.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var Callbacks = require("../core/utils/callbacks");
module.exports = new Callbacks;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/themes_callback.js
// module id = 1273
// module chunks = 0